<template>
  <v-app>
    <v-main>
      <gmap-map
        ref="mapRef"
        style="width: 100%; height: 100%"
        :zoom="12"
        :center="mapCenter"
        :options="mapOptions"
      >
        <template #visible>
          <v-container :style="step === 'report' ? 'padding: 0' : ''">
            <v-row>
              <v-col
                :style="{
                  'margin-top': $vuetify.breakpoint.mdAndUp ? '6%' : '',
                }"
                offset-xl="2"
                xl="8"
                cols="12"
              >
                <v-tabs-items v-model="step">
                  <v-tab-item
                    value="address"
                    style="background-color: transparent"
                  >
                    <v-card
                      :loading="loading"
                      :disabled="loading"
                      loader-height="3"
                      dark
                      style="background-color: #00000099 !important;"
                    >
                      <template slot="progress">
                        <v-progress-linear
                          color="red"
                          indeterminate
                        />
                      </template>
                      <h4 class="justify-center worth-title">
                        <v-icon
                          class="mr-4"
                          size="40"
                        >
                          mdi-home
                        </v-icon>
                        What's Your Home Worth?
                      </h4>
                      <p class="mt-2">
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="7"
                            >
                              <gmap-autocomplete
                                class="introInput"
                                @place_changed="setPlace"
                              >
                                <template v-slot:input="slotProps">
                                  <v-text-field
                                    ref="input"
                                    solo
                                    light
                                    prepend-inner-icon="mdi-map-marker"
                                    placeholder="Enter Your Address"
                                    :rules="rules.required"
                                    @listeners="slotProps.listeners"
                                    @attrs="slotProps.attrs"
                                  />
                                </template>
                              </gmap-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="3"
                              md="2"
                            >
                              <v-text-field
                                v-model="unit"
                                type="text"
                                solo
                                light
                                maxlength="5"
                                placeholder="Unit #"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="3"
                            >
                              <v-btn
                                block
                                x-large
                                color="success"
                                :disabled="place == null"
                                @click="getValue"
                              >
                                Get My Value
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <template v-if="loading">
                                <v-skeleton-loader type="paragraph" color="primary" />
                              </template>
                              <template v-else>
                                <p class="text-center white--text">
                                  {{ companyName }} and {{ agentFullName? agentFullName : 'Agent' }} do not intend to solicit properties currently listed by other agents.
                                </p>

                                <p class="text-center white--text" v-if="companyPhone">
                                  If you have any questions feel free to give us
                                  a call at
                                  <a
                                    class="white--text"
                                    :href="'tel:' + companyPhone"
                                  >{{ companyPhone }}</a>.
                                </p>
                              </template>
                            </v-col>
                          </v-row>
                        </v-container>
                      </p>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="property">
                    <v-card
                      :loading="loading"
                      :disabled="loading"
                      dark
                      style="background-color: #00000099 !important;"
                    >
                      <template slot="progress">
                        <v-progress-linear
                          color="blue"
                          indeterminate
                        />
                      </template>
                      <h4 style="color: #fff !important; font-size: 1.5rem">
                        <v-icon class="mr-4">
                          mdi-home
                        </v-icon>
                        Verify Property Details
                      </h4>
                      <v-card-subtitle style="color: hsla(0,0%,100%,.7) !important;">
                        Verify your property details for an accurate value
                      </v-card-subtitle>
                      <p>
                        <v-container fluid>
                          <v-form ref="property">
                            <v-row>
                              <v-col
                                cols="12"
                                md="6"
                              >
                                <v-row>
                                  <v-col
                                    md="6"
                                    class="pa-0"
                                    cols="12"
                                  >
                                    <v-text-field
                                      v-model="lead.name"
                                      label="Name"
                                      class="pa-3"
                                      hide-detail="auto"
                                      solo
                                      dense
                                      light
                                      :rules="rules.required"
                                    />
                                    <v-text-field
                                      v-model="lead.email"
                                      label="Email"
                                      hide-detail="auto"
                                      class="pa-3"
                                      solo
                                      dense
                                      light
                                      :rules="rules.email"
                                    />
                                    <HjPhoneField
                                      :value="lead.phone"
                                      @input="lead.phone = $event.replace(/[^0-9]/g, '')"
                                      label="Phone"
                                      class="pa-3"
                                      style="padding-top: 24px !important"
                                      hide-detail="auto"
                                      solo
                                      light
                                      dense
                                      :rules="rules.phone"
                                    />
                                  </v-col>
                                  <v-col
                                    md="6"
                                    class="pa-0"
                                    cols="12"
                                  >
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="property.parcel
                                            .standardized_land_use_type
                                          "
                                          label="Property Type"
                                          readonly
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="property.structure.beds_count
                                          "
                                          label="Beds"
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="property.structure.baths"
                                          label="Baths"
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="property.structure.total_area_sq_ft
                                          "
                                          label="Size"
                                          suffix="SqFt"
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="property.parcel.area_acres"
                                          label="Lot Size"
                                          suffix="Acres"
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col
                                cols="6"
                                class="d-none d-md-flex"
                              >
                                <iframe
                                  frameborder="0"
                                  style="border: 0; width: 100%; height: 100%"
                                  :src="embeddedMapLink"
                                  allowfullscreen=""
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="6"
                                offset-md="3"
                              >
                                <div class="padding-left-5">
                                    <input type="checkbox" id="form-field-type" name="type" value="seller">
                                    <label for="form-field-type" style="color: hsla(0,0%,100%,.7) !important;">I want to know how much my home is worth</label><br>
                                </div>
                                <div class="padding-left-5">
                                  <input id="optin" type="checkbox" value="1" name="text_optin">
                                  <label for="optin" style="color: hsla(0,0%,100%,.7) !important;">I would like to receive text messages*</label>
                                </div>
                                <v-btn
                                  block
                                  color="success"
                                  x-large
                                  :loading="confirmLoading"
                                  @click="confirmProperty"
                                >
                                  Get My Value
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </p>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="report">
                    <template v-if="currentUser">
                      <v-card
                        dark
                        style="background-color: #00000099 !important; border-radius: var(--border-radius-primary) !important"
                        tile
                      >
                        <h4 class="text-center justify-center mb-3" style="color: white !important;">
                          HOME VALUE REPORT FOR
                        </h4>
                        <v-card-subtitle
                          v-if="place"
                          class="address-report"
                          style="color: white !important;"
                        >
                          {{ place.formatted_address }}
                        </v-card-subtitle>
                      <v-container>
                        <v-row>
                          <v-col
                            md="9"
                            cols="12"
                          >
                            <v-card class="mt-4">
                              <h4 class="justify-center" style="color: white !important;">
                                ESTIMATED HOME VALUE:
                              </h4>
                              <template
                                v-if="property.valuation &&
                                  property.valuation.low &&
                                  property.valuation.high
                                "
                              >
                                <v-card-subtitle class="money-range justify-center my-4 text-center" style="color: white !important;">
                                  {{ currency(property.valuation.low) }} -
                                  {{ currency(property.valuation.high) }}
                                </v-card-subtitle>
                                <p>
                                  <v-dialog
                                    ref="sellDialog"
                                    max-width="500"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        block
                                        color="orange"
                                        class="mb-4"
                                        v-on="on"
                                      >
                                        Sell for this price
                                      </v-btn>
                                    </template>
                                    <v-card style="background-color: white !important;">
                                      <h4>
                                        Interested in selling for this
                                        price?
                                      </h4>
                                      <v-card-subtitle>
                                        Due to the current demand for properties
                                        like yours, you may qualify for a quick
                                        sale at the price listed on your Home
                                        Value Report. You may also NET up to
                                        <span
                                          style="color: red"
                                          class="font-weight-bold"
                                        >18% more</span>
                                        on the sale of your home.

                                        <template v-if="agent">
                                          Your Expert
                                          Advisor for
                                          {{
                                            property.neighborhood
                                              ? property.neighborhood
                                              : "your neighborhood"
                                          }}
                                          is {{ agentFullName }}.
                                        </template>

                                        Find out how
                                        much your home might sell for and what
                                        your net proceeds could be.<br>
                                        Confirm your contact information:
                                      </v-card-subtitle>
                                      <p>
                                        <v-form ref="sell">
                                          <HjPhoneField
                                            :value="currentUser.phone"
                                            @input="currentUser.phone = $event.replace(/[^0-9]/g, '')"                                         
                                            label="Phone"
                                            :rules="rules.phone"
                                          />
                                          <v-text-field
                                            v-model="currentUser.email"
                                            label="Email"
                                            :rules="rules.email"
                                          />
                                          <v-select
                                            v-model="sellingWhen"
                                            :items="sellingWhenList"
                                            :rules="rules.required"
                                            label="When do you want to sell?"
                                            class="white-dropdown"
                                            :menu-props="{ contentClass: 'white-dropdown-menu' }"
                                          />
                                        </v-form>
                                        <v-btn
                                          color="success"
                                          :loading="submitLoading"
                                          @click="
                                            sendMessage(
                                              $refs.sell,
                                              'sell',
                                              $refs.sellDialog
                                            )
                                          "
                                        >
                                          Submit
                                        </v-btn>
                                      </p>
                                    </v-card>
                                  </v-dialog>

                                  <v-dialog
                                    ref="lowDialog"
                                    max-width="500"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        block
                                        outlined
                                        class="my-4"
                                        v-on="on"
                                      >
                                        Price too low?
                                      </v-btn>
                                    </template>
                                    <v-card style="background-color: white !important;">
                                      <h4>Price too low?</h4>
                                      <v-card-subtitle>
                                        Your home may have upgrades or features
                                        that can’t be factored into an online
                                        value estimate.

                                        Your Expert Advisor for
                                        {{
                                          property.neighborhood
                                            ? property.neighborhood
                                            : "your neighborhood"
                                        }} can provide
                                        you with an accurate value based on
                                        information from the MLS as well as
                                        expert knowledge on the current state of
                                        the market in
                                        {{
                                          property.neighborhood
                                            ? property.neighborhood
                                            : "your neighborhood"
                                        }}
                                        at no cost to you.
                                        <br>
                                        Confirm your contact information:
                                      </v-card-subtitle>
                                      <p>
                                        <v-form ref="low">
                                          <HjPhonefield
                                            :value="currentUser.phone"
                                            @input="currentUser.phone = $event.replace(/[^0-9]/g, '')"
                                            label="Phone"
                                            :rules="rules.phone"
                                          />
                                          <v-text-field
                                            v-model="currentUser.email"
                                            label="Email"
                                            :rules="rules.email"
                                          />
                                          <v-select
                                            v-model="howFarOff"
                                            :items="howFarOffOptions"
                                            :rules="rules.required"
                                            label="How far off do you think your value estimate is"
                                            class="white-dropdown"
                                            :menu-props="{ contentClass: 'white-dropdown-menu' }"
                                          />
                                        </v-form>
                                        <v-btn
                                          color="success"
                                          :loading="submitLoading"
                                          @click="
                                            sendMessage(
                                              $refs.low,
                                              'low',
                                              $refs.lowDialog
                                            )
                                          "
                                        >
                                          Submit
                                        </v-btn>
                                      </p>
                                    </v-card>
                                  </v-dialog>

                                  <v-btn
                                    block
                                    outlined
                                    class="my-4"
                                    @click="redirect('/')"
                                  >
                                    Return to Homepage
                                  </v-btn>
                                </p>
                              </template>
                              <p v-else>
                                <v-alert color="warning">
                                  Our automated system has failed to return a
                                  reasonable estimate of your property value in
                                  a timely manner, we apologize for this
                                  inconvenience. We will be in touch shortly
                                  with your property value estimate once
                                  complete.
                                </v-alert>
                              </p>
                            </v-card>
                          </v-col>
                          <v-col
                            v-if="agent"
                            md="3"
                            cols="12"
                          >
                            <v-card>
                              <h4 class="justify-center">
                                <h3 class="text-center" style="color: white !important;">
                                  HAVE QUESTIONS?
                                </h3>
                              </h4>
                              <p class="text-center" style="color: white !important;">
                                Get instant Expert Advice
                                <template v-if="agent">
                                  from {{ agentFullName }}.
                                </template>
                              </p>
                              <v-img
                                :src="`${apiBaseUrl}/agentProfileImg?id=${agent.id}`"
                                max-height="200px"
                                contain
                              />
                              <p style="color: white !important;">
                                <template v-if="agent">
                                  <p class="agent-details">
                                    <strong>{{ agentFullName }}</strong><br>
                                    <template v-if="agent.c_phone">
                                      Direct:
                                      <a :href="'tel:' + cleanPhone(agent.c_phone)" style="color: white !important;">{{ cleanPhone(agent.c_phone)
                                      }}</a><br>
                                    </template>
                                    Email:
                                    <a
                                      :href="`mailto:${agent.email.toLowerCase()}`"
                                      :title="agent.email.toLowerCase()"
                                      style="color: white !important;"
                                    >{{
                                      agent.email.toLowerCase() }}</a>
                                  </p>
                                </template>
                                <v-dialog
                                  ref="valuationDialog"
                                  max-width="500"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      block
                                      color="orange"
                                      style="color: white !important;"
                                      class="mb-4"
                                      v-on="on"
                                    >
                                      Free Valuation
                                    </v-btn>
                                  </template>
                                  <v-card style="background-color: white !important;">
                                    <h4>
                                      Free Expert Agent
                                      Evaluation
                                    </h4>
                                    <v-card-subtitle>
                                      Your Expert Advisor for
                                      {{
                                        property.neighborhood
                                          ? property.neighborhood
                                          : "your neighborhood"
                                      }} can provide you
                                      with an accurate value based on
                                      information from the MLS as well as expert
                                      knowledge on the current state of the
                                      market in
                                      {{
                                        property.neighborhood
                                          ? property.neighborhood
                                          : "your neighborhood"
                                      }}
                                      at no cost to you.
                                      <br>
                                      Confirm your contact information:
                                    </v-card-subtitle>
                                    <p>
                                      <v-form ref="valuation">
                                        <HjPhoneField
                                          :value="currentUser.phone"
                                          @input="currentUser.phone = $event.replace(/[^0-9]/g, '')"
                                          label="Phone"
                                          :rules="rules.phone"
                                        />
                                        <v-text-field
                                          v-model="currentUser.email"
                                          label="Email"
                                          :rules="rules.email"
                                        />
                                        <v-select
                                          v-model="howFarOff"
                                          :items="howFarOffOptions"
                                          :rules="rules.required"
                                          label="How far off do you think your value estimate is"
                                          class="white-dropdown"
                                          :menu-props="{ contentClass: 'white-dropdown-menu' }"
                                        />
                                      </v-form>
                                      <v-btn
                                        color="success"
                                        :loading="submitLoading"
                                        @click="
                                          sendMessage(
                                            $refs.valuation,
                                            'valuation',
                                            $refs.valuationDialog
                                          )
                                        "
                                      >
                                        Submit
                                      </v-btn>
                                    </p>
                                  </v-card>
                                </v-dialog>
                                <v-dialog
                                  v-if="agent"
                                  ref="contactDialog"
                                  max-width="500"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      block
                                      outlined
                                      color="orange"
                                      class="my-4"
                                      v-on="on"
                                    >
                                      Contact {{ agent.first_name }}
                                    </v-btn>
                                  </template>
                                  <v-card style="background-color: white !important;">
                                    <h4>Contact {{ agentFullName }}</h4>
                                    <v-card-subtitle>
                                      {{ agentFullName }} is your Expert
                                      Advisor for
                                      {{
                                        property.neighborhood
                                          ? property.neighborhood
                                          : "your neighborhood"
                                      }}. {{ agent.first_name }} has expert
                                      knowledge on the current state of the
                                      market in
                                      {{
                                        property.neighborhood
                                          ? property.neighborhood
                                          : "your neighborhood"
                                      }}
                                      and can answer any questions you have
                                      about your home, neighborhood, or the real
                                      estate market at no cost to you.
                                      <br>
                                      Confirm your contact information:
                                    </v-card-subtitle>
                                    <p>
                                      <v-form ref="contact">
                                        <HjPhoneField
                                          :value="currentUser.phone"
                                          @input="currentUser.phone = $event.replace(/[^0-9]/g, '')"
                                          label="Phone"
                                          :rules="rules.phone"
                                        />
                                        <v-text-field
                                          v-model="currentUser.email"
                                          label="Email"
                                          :rules="rules.email"
                                        />
                                        <v-textarea
                                          v-model="message"
                                          label="Message"
                                          :rules="rules.required"
                                        />
                                      </v-form>
                                      <v-btn
                                        color="success"
                                        :loading="submitLoading"
                                        @click="
                                          sendMessage(
                                            $refs.contact,
                                            'contact',
                                            $refs.contact
                                          )
                                        "
                                      >
                                        Submit
                                      </v-btn>
                                    </p>
                                  </v-card>
                                </v-dialog>
                              </p>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      </v-card>
                    </template>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <GmapMarker
          v-if="place"
          label="★"
          :animation="2"
          :radius="place.radius ? place.radius * 1609.34 : 0"
          :position="{
            lat: place.latitude,
            lng: place.longitude,
          }"
        >
          <GmapCircle
            v-if="filterArea"
            :ref="'circleRef' + filterArea.admin_id"
            :key="filterArea.admin_id"
            :center="{ lat: parseFloat(filterArea.lat), lng: parseFloat(filterArea.lng) }"
            :radius="filterArea.radius * 1609.34"
            :visible="true"
            :options="{
              fillColor: filterArea.primary == 0 ? '#000000' : '#899df5',
              fillOpacity: 0.3,
              strokeOpacity: 1,
              strokeWeight: 2,
              strokeColor: filterArea.primary == 0 ? '#000000' : '#899df5',
            }"
          />
        </GmapMarker>
      </gmap-map>
      <v-dialog
        v-model="loginDialog"
        max-width="500"
      >
        <v-card>
          <h4>Looks like you're coming here from Google.</h4>
          <v-card-subtitle>
            Please Login with your google account or your email and phone
            number
          </v-card-subtitle>
          <p>
            <v-row>
              <v-col
                cols="12"
                class="text-center"
              >
                <v-btn
                  dark
                  block
                  color="green"
                  @click="
                    redirect('/api/v1/connected-accounts/googleLoginOauthUrl')
                  "
                >
                  <v-icon>mdi-google</v-icon>
                  Sign In
                </v-btn>
              </v-col>
            </v-row>
          </p>
        </v-card>
      </v-dialog>
    </v-main>
    <v-footer>
      <v-spacer />
      <p class="text-center">
        I agree to receive marketing and customer service calls and text messages from {{ agentFullName ? agentFullName + ' and ' : '' }} {{ companyName.toUpperCase().replace(' PPC', '') }}. Consent is not a condition of purchase. Msg/data rates may apply. Msg frequency varies. Reply STOP to unsubscribe. 
        <a
          href="/termsOfService"
          target="_blank"
        >Terms of Use</a> and
        <a
          href="/privacyPolicy"
          target="_blank"
        >Privacy Policy</a>
      </p>
    </v-footer>
  </v-app>
</template>

<script>
import http from "@/mixins/http";
import clientMix from "@/mixins/client";
import phone from "@/mixins/formatters/phone";
import validators from "@/mixins/validators";
import { currency } from "@/util/helpers";
import { cleanGoogleAutocompleteData } from "@/util/utils";
import HjPhoneField from "@/components/HouseJet/HjPhoneField.vue";
export default {
  name: "HomeValues",
  components: { HjPhoneField },
  mixins: [http, clientMix, phone, validators],
  data() {
    return {
      loading: true,
      mapOptions: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        draggable: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
      },
      mCenter: null,
      step: "address",
      place: null,
      serviceAreas: [],
      filterArea: {},
      unit: null,
      property: {
        parcel: {},
        structure: {},
      },
      purpose: undefined,
      purposeList: ["Looking to Sell", "Tax Purposes", "Refinancing"],
      sellingWhen: undefined,
      sellingWhenList: [
        "Immediately",
        "3 Months",
        "6 Months",
        "1 Year",
        "More than a year",
      ],
      howFarOffOptions: [
        { text: "Under $10,000", value: "Under $10,000" },
        { text: "$10,001 - $20,000", value: "$10,001 - $20,000" },
        { text: "$20,001 - $50,000", value: "$20,001 - $50,000" },
        { text: "$50,001 - $100,000", value: "$50,001 - $100,000" },
        { text: "Over $100,000", value: "Over $100,000" },
      ],
      howFarOff: undefined,
      propertyError: false,
      lead: {
        name: "",
        email: "",
        phone: "",
        photo: undefined,
      },
      tempUser: null,
      loginDialog: false,
      agent: undefined,
      FrontendPhone: "",
      phone: undefined,
      email: undefined,
      name: undefined,
      loginLoading: false,
      registerLoading: false,
      message: undefined,
      confirmLoading: false,
      currentUser: false,
      submitLoading: false,
    };
  },
  computed: {
    apiBaseUrl() {
      return window.IS_MOBILE_APP ? 'https://api.housejet.com' : ''
    },
    purposeValid() {
      return this.purpose;
    },
    sellingWhenValid() {
      return this.purpose === "Looking to Sell" && this.sellingWhen;
    },
    embeddedMapLink() {
      if (this.place)
        return (
          "https://www.google.com/maps/embed/v1/place?zoom=20&maptype=satellite&q=" +
          this.place.formatted_address +
          "&key=AIzaSyBC7Z6nNR2uNFnYzKDJemCQSA4SK03JpiM"
        );

      return "";
    },
    companyPhone() {
      if ( !this.FrontendPhone ) return null
      return this.cleanPhone(this.FrontendPhone);
    },
    companyName() {
      return this.client?.company_name ? this.client.company_name : '';
    },
    mapCenter() {
        return this.mCenter ? this.mCenter : {}
    },
    agentFullName(){
      return this.agent ? this.agent.full_name : ''
    }
  },
  async mounted() 
  {
    this.loading = true;
    await Promise.all([
      await this.getClientData(),
      await this.getAgentData(),
      await this.getClientServiceArea()
    ]);

    if (this.serviceAreas && this.serviceAreas.length > 0) 
    {
      const getPrimaryService = this.serviceAreas.find(area=> area.primary === "1")
      if (getPrimaryService) 
      { 
        const lat = Number(getPrimaryService.lat);
        const lng = Number(getPrimaryService.lng);
  
      if (!isNaN(lat) && !isNaN(lng)) {
        this.mCenter = {
          lat,
          lng,
      };
  } else {
    console.error('Invalid latitude or longitude value');
  }

      }
      else 
      {
        this.mCenter = null;
      }
    } 
    else 
    {
      this.mCenter = null;
    }

    if (this.findGetParameter("register")) {
      this.lead.email = this.findGetParameter("email");
      this.lead.name = this.findGetParameter("name");
      this.lead.photo = this.findGetParameter("photo");
    } else if (!this.currentUser && this.findGetParameter("g") === "1") {
      this.loginDialog = true;
    }
    this.getCurrentLead();
    this.loading = false;
  },
  methods: {
async setPlace(place) {
  let newplace = cleanGoogleAutocompleteData(place);
  
  // Check if the place object already has a valid latitude and longitude
  if (newplace.latitude && newplace.longitude) {
    this.place = newplace;
  } else {
    let filterServiceArea = this.serviceAreas.filter((sArea) => {
      return sArea.city === newplace.locality && sArea.primary == 1;
    });
    if (filterServiceArea.length == 0) {
      filterServiceArea = this.serviceAreas.filter((sArea) => {
        return sArea.city === newplace.locality;
      });
    }
    if (filterServiceArea.length > 0) {
      this.filterArea = filterServiceArea[0]
      newplace.latitude = parseFloat(filterServiceArea[0].lat);
      newplace.longitude = parseFloat(filterServiceArea[0].lng);
      newplace.radius = parseFloat(filterServiceArea[0].radius);
    } else {
      newplace.radius = null;
    }
    this.place = newplace;
  }
  
  if (!this.place) {
    return;
  }
  const map = await this.$refs.mapRef.$mapPromise;

  map.panTo({
    lat: this.place.latitude + 0.05,
    lng: this.place.longitude,
  });
},
    async getValue() {
      this.step = "property";
      this.loading = true;
      if (this.unit) {
        let updatedPlaceName =
          this.place.name + " apt " + this.unit.replace(/\s+/g, "");
        this.place.formatted_address = this.place.formatted_address.replace(
          this.place.name,
          updatedPlaceName
        );
        this.place.name = updatedPlaceName;
      }
      const {
        data: { property, agent, message, lead, errors },
        status,
      } = await this.$http
        .post("/api/pub/client-leads/homeValueReport", {
          place: this.place,
          lead: this.lead,
        })
        .catch((e) => e);

      this.loading = false;
      if (this.$error(status, message, errors)) return;
      this.property = property;
      this.agent = agent;
      // Don't auto-fill name to avoid scaring users with pre-populated personal data
      lead.name = '';
      this.lead = lead;
    },
    fireConversion() {
      // send the conversion event to google tag manager
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'lead_registered',
        'transaction_id' : this.currentUser.id
      });

      // return;
      if (this.client.head_conversion_code) {
        document
          .getElementById("conversion")
          .insertAdjacentHTML("beforeend", this.client.head_conversion_code);
      }
      if (this.client.body_conversion_code) {
        document
          .getElementById("conversion")
          .insertAdjacentHTML("afterbegin", this.client.body_conversion_code);
      }

      this.exec_body_scripts(document.getElementById("conversion"));
    },
    async confirmProperty() {
      if (!this.$refs.property.validate()) return;
      this.confirmLoading = true;
      const {
        data: { message, errors },
        status,
      } = await this.$http
        .post("/api/pub/client-leads/confirm-property", {
          property: this.property,
          lead: this.lead,
          agent: this.agent,
        })
        .catch((e) => e);
      this.confirmLoading = false;
      if (this.$error(status, message, errors)) return;
      await this.getCurrentLead();
      this.fireConversion();
      this.step = "report";
    },
    currency,
    async login() {
      if (!this.$refs.form.validate()) return;
      this.loginLoading = true;
      const {
        data: { success, error },
      } = await this.$http
        .post("/login", {
          email: this.email,
          password: this.phone,
        })
        .catch((e) => e);
      if (!success) {
        this.$noty.error(error);
        this.loginLoading = false;
        return;
      }
      await this.getCurrentLead();
      this.loginLoading = false;
      this.loginDialog = false;
    },
    async sendMessage(form, type, dialog) {
      if (!form.validate()) return;
      this.loading = true;
      this.submitLoading = true;

      const data = {
        rating: "6",
        email: this.currentUser.email,
        phone: this.currentUser.phone,
        user_id: this.currentUser.id,
        source: 'seller_quiz',
      };

      switch (type) {
        case "sell":
          data.subject = "Home Sale Assistance Request";
          data.message = `Assistance with a home sale has been requested. Calculated home price is between $${this.property.valuation.low} and $${this.property.valuation.high}. Preferred time of sale: ${this.sellingWhen}.`;
          break;
        case "low":
          data.subject = "Free Expert Agent Evaluation Request";
          data.message = `Free Home Evaluation from the Expert Agent has been requested. Calculated price ($${this.property.valuation.low} - $${this.property.valuation.high}) might be too low. Value is off by ${this.howFarOff}.`;
          break;
        case "valuation":
          data.subject = "Free Expert Agent Evaluation Request";
          data.message = `Free Home Evaluation from the Expert Agent has been requested.`;
          break;
        case "contact":
          data.subject = "Home Valuation Contact Request";
          data.message = this.message;
          break;
      }

      const {
        data: { message, errors },
        status,
      } = await this.$http
        .post("/ajaxSendHomeValueMessageToAgent", data)
        .catch((e) => e);
      this.loading = false;
      this.submitLoading = false;
      if (this.$error(status, message, errors)) return;
      
      // Close dialog by setting its model value to false
      if (dialog && dialog.hasOwnProperty('isActive')) {
        dialog.isActive = false;
      } else if (dialog) {
        dialog = false;
      }

      // Also close using refs
      const dialogRefs = {
        sell: 'sellDialog',
        low: 'lowDialog',
        valuation: 'valuationDialog',
        contact: 'contactDialog'
      };
      
      if (type in dialogRefs && this.$refs[dialogRefs[type]]) {
        this.$refs[dialogRefs[type]].isActive = false;
      }
    },
    async getCurrentLead() {
      let {
        data: { user, message, errors },
        status,
      } = await this.$http
        .get("/api/lead/client-leads/getCurrentLead")
        .catch((e) => e);
      if (this.$error(status, message, errors)) return;
      this.currentUser = user;
    },
    async getClientServiceArea() {

      if (!this.agent?.id) return

      let {
        data: { serviceAreas, success },
      } = await this.$http.get(
        "/api/v1/agent-service-areas/view/" + this.agent.id
      );
      if (success && serviceAreas.length > 0) {
        this.serviceAreas = serviceAreas;
      }
    },
    exec_body_scripts(body_el) {
      // Finds and executes scripts in a newly added element's body.
      // Needed since innerHTML does not run scripts.
      //
      // Argument body_el is an element in the dom.

      // main section of function
      let scripts = [],
        script,
        children_nodes = body_el.childNodes,
        child,
        i;
      console.log(children_nodes);
      for (i = 0; children_nodes[i]; i++) {
        child = children_nodes[i];
        if (
          this.nodeName(child, "script") &&
          (!child.type || child.type.toLowerCase() === "text/javascript")
        ) {
          scripts.push(child);
        }
      }

      for (i = 0; scripts[i]; i++) {
        script = scripts[i];
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        this.evalScript(scripts[i]);
      }
    },
    nodeName(elem, name) {
      return (
        elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase()
      );
    },
    evalScript(elem) {
      let data = elem.text || elem.textContent || elem.innerHTML || "",
        head =
          document.getElementsByTagName("head")[0] || document.documentElement,
        script = document.createElement("script");

      script.type = "text/javascript";
      try {
        // doesn't work on ie...
        script.appendChild(document.createTextNode(data));
      } catch (e) {
        // IE has funky script nodes
        script.text = data;
      }

      head.insertBefore(script, head.firstChild);
      head.removeChild(script);
    },

    async getAgentByAlias(alias) {
      let {
        data: { agent },
      } = await this.$http.get("/api/v1/admins/get-by-alias/" + alias);

      this.agent = agent;
    },

    async getDefaultAgent() {
      let {
        data: { agent },
      } = await this.$http.get("/api/v1/admins/get-frontend-agent");
      this.agent = agent;
      this.FrontendPhone = agent?.c_phone
    },

    async getAgentData() {
      // find the agent by their alias
      if (this.findGetParameter("i")) {
        this.getAgentByAlias(this.findGetParameter("i"));
      }

      await this.getDefaultAgent();
    }
  },
};
</script>

<style lang="scss" scoped>
.worth-title {
  font-size: 40px;
  padding-top: 78px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  word-break: break-word;
  line-height: 60px;
  color: white !important;
}

.address-report {
  font-size: 25px;
  line-height: 26px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
}

::v-deep .theme--light.v-tabs-items {
  background-color: transparent;
}

.money-range {
  font-size: 28px;
  font-weight: bold;
  color: black !important;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #000;
  }

  &:not(:empty) {
    &::before {
      margin-right: 0.25em;
    }

    &::after {
      margin-left: 0.25em;
    }
  }
}

::v-deep .theme--dark.v-label{
  color: hsla(0,0%,100%,.7) !important;
}

/* White background for dropdown menus */
::v-deep .white-dropdown-menu {
  background-color: white !important;
}

::v-deep .white-dropdown-menu .v-list {
  background-color: white !important;
}

::v-deep .white-dropdown-menu .v-list-item {
  background-color: white !important;
}
</style>

<style lang="scss">
@import '@/sass/custom-styles.scss';
</style>

<style>
@import url('/main.style.css');
</style>
